/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Meta_DescInputs */

const en_simple_oto_meta_desc = /** @type {(inputs: Simple_Oto_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your idea, Bystep builds it, you try it on your phone. No jargon.`)
};

const id_simple_oto_meta_desc = /** @type {(inputs: Simple_Oto_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu, Bystep membangun, kamu coba di HP. Tanpa istilah teknis.`)
};

/**
* | output |
* | --- |
* | "Describe your idea, Bystep builds it, you try it on your phone. No jargon." |
*
* @param {Simple_Oto_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_meta_desc = /** @type {((inputs?: Simple_Oto_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_meta_desc(inputs)
	return en_simple_oto_meta_desc(inputs)
});